<template>
  <div
    class="tr-select"
    :class="[{ 'position-inherit': elementTopPosition ? false : true }]"
    :style="getTrSelectStyle(config)"
  >
    <b-form-select
      v-model="selectVal"
      size="lg"
      :disabled="trSelectValue.block === true"
      @change="emitNewValue($event)"
      @click.native="resetCheckStatus"
      :style="getTrSelectStyle(config)"
      :class="[
        { 'inline-input-disabled': trSelectValue.block === true },
        { 'inline-input-correct': trSelectValue.inputStatus === 'correct' },
        { 'inline-input-wrong': trSelectValue.inputStatus === 'incorrect' },
        { 'inline-input-text-aling-center': elementTextAlign === 'center' },
        { 'inline-input-text-aling-left': elementTextAlign === 'left' },
        { 'inline-input-text-aling-right': elementTextAlign === 'right' },
      ]"
    >
      <b-form-select-option
        :value="option"
        class="option-style"
        v-for="(option, index) in options"
        :key="'option_' + index"
        :style="{ 'font-size': listFontSize + 'px' }"
      >
        {{ option.text }}
      </b-form-select-option>
    </b-form-select>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
export default {
  name: 'tr-select',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    trSelectValue: {
      type: Object,
      default: function () {
        return {};
      },
    },
    offsetHorizontal: {
      type: Number,
      default: 0,
    },
    offsetVertical: {
      type: Number,
      default: 0,
    },
    inputWidth: {
      type: null,
      default: '',
    },
    inputHeight: {
      type: null,
      default: '',
    },
    maxLength: {
      type: null,
      default: 255,
    },
    listFontSize: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  created() {},
  mounted() {},
  methods: {
    emitNewValue(value) {
      // console.log( 'value', value );
      this.$emit('change', value);
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getTrSelectStyle(item) {
      return _.merge({}, this.getCustomStyle(item), {
        top: this.elementTopPosition,
        left: this.elementLeftPosition,
        width: this.elementWidth,
        height: this.elementHeight + ' !important',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    selectVal: {
      get() {
        return this.trSelectValue.val;
      },
      set(newValue) {
        if (!this.trSelectValue.block) {
          this.trSelectValue.val = newValue;
        }
      },
    },
    getListFontSize() {
      return this.config.listFontSize;
    },
    elementTopPosition() {
      return this.config && this.config.pos
        ? utils.elementTopPosition(this.config.pos.y || 0, this.offsetVertical)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config.pos
        ? utils.elementLeftPosition(this.config.pos.x || 0, this.offsetHorizontal)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.inputWidth);
    },
    elementHeight() {
      return utils.elementHeight(this.inputHeight);
    },
    elementTextAlign() {
      let align = 'center';
      if (this.config && this.config.align) {
        align = this.config.align;
      }
      return align;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
// @import '~@/assets/sass/inputBase';
$inlineInputwrongColor: rgb(196, 29, 29);
$inputTextColor: rgb(0, 0, 0);
$inputTextBackgroundColor: rgb(255, 255, 255);
$inputTextDisabled: rgb(235, 235, 235);
$input3DShadow: rgb(179, 179, 179);
$selectTextDisableColor: #575c61;
.inline-input {
  display: inline-flex;
  color: $inputTextColor !important;
  background-color: $inputTextBackgroundColor;
  // box-shadow: inset 0 0 10px 0 $input3DShadow !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: baseline;
  &:focus {
    color: $inputTextColor;
    outline: none;
  }
}
.inline-input-wrong {
  background-color: rgba($inlineInputwrongColor, 0.1) !important;
  color: $inlineInputwrongColor !important;
}
.inline-input-disabled {
  user-select: none;
  background-color: $inputTextDisabled;
}
.inline-input-correct {
  color: $inputTextColor;
  // box-shadow: inset 0 0 10px 0 $firstIconColor !important;
  background-color: rgba($firstIconColor, 0.6) !important;
}
.tr-input-text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.2%;
  text-align: center;
}
.inline-input-text-aling-center {
  text-align: center;
}
.inline-input-text-aling-left {
  text-align: left;
}
.inline-input-text-aling-right {
  text-align: right;
}
.tr-select {
  display: inline-flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: $bacgroundColor;
  select {
    // background-size: p20px 27px;
    background-size: 17px 17px !important;
  }
  .form-control {
    font-size: 35px !important;
    height: 70px !important;
    option {
      // width: 1.5em !important;
      font-size: 22px !important;
    }
  }
}

.position-inherit {
  position: inherit;
}
</style>
